import { Component, Input, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { ProgramEditorService } from "../program-editor.service";
import { TypesService } from "../../types.service";
import { Subscription } from "rxjs/Subscription";

import { Program, ProgramRequestSubmission } from "@models/program";
import { ActNowDictionaryItem } from "@models/common";

declare var jQuery: any;

@Component({
    templateUrl: "./program-request-submission.component.html",
    selector: "app-request-submit-editor"
})

export class ProgramRequestSubmissionComponent implements OnInit, OnDestroy {
    public errorsSub: Subscription;
    public updateValidationSub: Subscription;
    public showErrors: boolean = false;
    public model: ProgramRequestSubmission;

    public nameValid: boolean = false;
    public emailValid: boolean = false;
    public phoneValid: boolean = false;
    public codeValid: boolean = false;

    public dataReadySub: Subscription;

    constructor(private editorService: ProgramEditorService) { }
    ngOnInit(): void {
        this.editorService.updateCurrentTab(4);
        this.getData();
        this.subscribeToErrors();
        this.subscribeToValidationUpdates();
    }

    ngOnDestroy(): void {
        if (this.errorsSub != undefined) {
            this.errorsSub.unsubscribe();
        }
        if (this.updateValidationSub != undefined) {
            this.updateValidationSub.unsubscribe();
        }
    }

    getData(): void {
        let ready = this.editorService.dataReady;
        if (ready) {
            let program = this.editorService.getProgram();
            if (program.submit == undefined) {
                this.model = new ProgramRequestSubmission();
                this.updateProgram();
            } else {
                this.model = program.submit;
            }

            this.validate();
            if (this.dataReadySub != undefined) {
                this.dataReadySub.unsubscribe();
            }
        } else {
            this.dataReadySub = this.editorService.dataReady$.subscribe(x => this.getData());
        }
    }

    subscribeToErrors(): void {
        this.errorsSub = this.editorService.showSubmitErrors$.subscribe(x => {
            this.showErrors = x;
        });
    }

    subscribeToValidationUpdates(): void {
        this.updateValidationSub = this.editorService.updateSubmitValidation.subscribe(x => this.validate());
    }

    updateProgram(): void {
        this.validate();
        let program = this.editorService.getProgram();
        program.submit = this.model;
        this.editorService.updateProgram(program);
    }

    validate(): void {
        this.nameValid = this.stringPopulated(this.model.name);
        this.emailValid = this.stringPopulated(this.model.email);
        this.phoneValid = this.stringPopulated(this.model.phoneNumber);
        this.codeValid = this.stringPopulated(this.model.captchaCode);

        if (this.emailValid) {
            let regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            this.emailValid = regex.test(this.model.email);
        }

        let valid = this.nameValid && this.emailValid && this.phoneValid && this.codeValid;

        this.editorService.updateSubmissionValidity(valid);
    }

    stringPopulated(value: string) {
        if (value == undefined) {
            return false;
        }

        return value.replace(/\s/g, "").length > 0;
    }
}



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/app/common/program-editors/submit/program-request-submission.component.ts